/**
 * Get Product Recommendations Action
 * Triggered by: arc:action:getRecommendations
 *
 * Delegates to the active search provider's getRecommendations() method.
 *
 * event.detail:
 *   blockId      {string}        - Unique block ID for event namespacing
 *   productId    {string|number} - Seed product Shopify numeric ID
 *   intent       {string}        - Shopify: 'RELATED' | 'COMPLEMENTARY'
 *   tags         {string}        - SearchSpring: comma-separated profile tag(s)
 *   limit        {number}        - Max products to return
 *   cartItemIds  {string}        - Comma-separated numeric product IDs in cart
 */

import { createProvider } from '@js/providers/providerFactory.js';

export const runGetRecommendations = async (data = {}) => {
  const { blockId, productId, intent, tags, limit = 10, cartItemIds } = data;

  try {
    const provider = await createProvider(window.search?.provider || 'shopify');
    const products = await provider.getRecommendations({ productId, intent, tags, limit, cartItemIds });

    const eventName = blockId ? `recommendations:fetched:${blockId}` : 'recommendations:fetched';
    window.dispatchEvent(new CustomEvent(eventName, { detail: { products } }));

    return { success: true, products };
  } catch (error) {
    console.error('[Recommendations] Error fetching recommendations:', error);

    const eventName = blockId ? `recommendations:error:${blockId}` : 'recommendations:error';
    window.dispatchEvent(new CustomEvent(eventName, { detail: { error: error.message } }));

    return { success: false, error: error.message };
  }
};

